import { changeOrderTypeEndpoint, sendPostRequest } from '../../api/backend';
import { renderErrorMessage, sendCloudWatchAlert } from '../../utils';
import { showMessageModal, showOrderStatus } from '../../redux/actions';
import store from '../../redux/store';
import {
  API_CANCEL_ORDER,
  CUSTOMER_CANCEL,
  CUSTOMER_CANCEL_PHASE_CONTACTING,
  CUSTOMER_CANCEL_PHASE_DELIVERING,
  CUSTOMER_CANCEL_PHASE_PREPARING,
  CUSTOMER_CANCEL_PHASE_TAKEAWAY,
  MODIFY_ORDER_TYPE_PROMOTION,
  ORDER_PHASE_CONTACTING,
  ORDER_PHASE_DELIVERING,
  ORDER_PHASE_PREPARING,
  ORDER_PHASE_TAKEAWAY,
} from '../../constants';

export const cancelOrder = async (
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  order:any
) => {
  try {
    const { user } = store.getState().userReducer;
    const { customerId } = user;
    const { status, chargeId, canal, orderNumber } = order;
    let cancelReason = '';
    switch (status) {
      case ORDER_PHASE_CONTACTING:
        cancelReason = CUSTOMER_CANCEL_PHASE_CONTACTING;
        break;
      case ORDER_PHASE_PREPARING:
        cancelReason = CUSTOMER_CANCEL_PHASE_PREPARING;
        break;
      case ORDER_PHASE_DELIVERING:
        cancelReason = CUSTOMER_CANCEL_PHASE_DELIVERING;
        break;
      case ORDER_PHASE_TAKEAWAY:
        cancelReason = CUSTOMER_CANCEL_PHASE_TAKEAWAY;
        break;
      default:
        break;
    }
    const cancellation = {
      canceledBy: CUSTOMER_CANCEL,
      cancelReason,
    };
    const data = {
      customerId,
      cancellation,
      chargeId,
      canal,
    };
    setIsLoading(true);
    await sendPostRequest(API_CANCEL_ORDER, data);
    store.dispatch(
      showMessageModal(`Votre commande n°${orderNumber} a bien été annulée`)
    );
    store.dispatch(showOrderStatus(false));
  } catch (error) {
    store.dispatch(
      showMessageModal(
        `Nous n'avons pas pu annuler votre commande n°${order.orderNumber}`
      )
    );
    sendCloudWatchAlert(`Error cancelling order ${error}`);
  }
  setIsLoading(false);
};

export const changeOrderType = async (
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setLoadingChanginOrderType: React.Dispatch<React.SetStateAction<boolean>>,
  order: any,
  newOrderType: string,
  refundReduction: number | undefined = undefined
) => {
  try {
    if (newOrderType === MODIFY_ORDER_TYPE_PROMOTION.REFUND) {
      const discountMessage = refundReduction > 0 ? 'Vous bénéficierez d\'une réduction sur votre prochaine commande.' : '';
      setIsLoading(true);
      await changeOrderTypeEndpoint(order, newOrderType);
      store.dispatch(showOrderStatus(false));
      store.dispatch(
        showMessageModal(
          `Votre commande n°${order.orderNumber} a été annulée avec succès. ${discountMessage}`
        )
      );
      return;
    }
    if (newOrderType === MODIFY_ORDER_TYPE_PROMOTION.CLICK_AND_COLLECT) {
      setLoadingChanginOrderType(true);
      await changeOrderTypeEndpoint(order, newOrderType);
    }
  } catch (error) {
    store.dispatch(showMessageModal(renderErrorMessage(error)));
    sendCloudWatchAlert(`Error changing order type ${error}`);
  }
  setIsLoading(false);
  setLoadingChanginOrderType(false);
};
